import React, { useState } from 'react';
import TriplexChatWindow from './TriplexChatWindow';
import './triplex-chat-widget.scss';

const TriplexChatWidget: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className={`triplex-ai-widget-btn ${open ? 'opened' : ''}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label="AI‑ассистент"
      >
        {open ? 'X' : 'AI-ассистент'}
      </button>
      {open && <TriplexChatWindow onClose={() => setOpen(false)} />}
    </>
  );
};

export default TriplexChatWidget;